import HeaderOutdoor from "./components/HeaderOutdoor";
import FooterOutdoor from "./components/FooterOutdoor";

// const initOUTERAnalytics = () => {
//   const ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@1.3.1";
//   /* eslint-disable*/

//   !(function(e, a, t, n, s, i, c) {
//     (e.AlgoliaAnalyticsObject = s),
//       (e[s] =
//         e[s] ||
//         function() {
//           (e[s].queue = e[s].queue || []).push(arguments);
//         }),
//       (i = a.createElement(t)),
//       (c = a.getElementsByTagName(t)[0]),
//       (i.async = 1),
//       (i.src = n),
//       c.parentNode.insertBefore(i, c);
//     console.log(e, a, t, n, s, i, c);
//   })(window, document, "script", ALGOLIA_INSIGHTS_SRC, "aa");

//   // Initialize library
//   global.aa("init", { appId: "KQ2XE2UCH0", apiKey: "7a08c23781abc566cbbfa382a86e30cb" });

//   console.log(aa);
// };
// initOUTERAnalytics();

if (!("customElements" in window)) {
  setTimeout(() => {
    if (!window.customElements.get("arcteryx-outdoor-header")) {
      window.customElements.define("arcteryx-outdoor-header", HeaderOutdoor);
    }

    if (!window.customElements.get("arcteryx-outdoor-footer")) {
      window.customElements.define("arcteryx-outdoor-footer", FooterOutdoor);
    }
  }, 5000);
}

if (!window.customElements.get("arcteryx-outdoor-header")) {
  window.customElements.define("arcteryx-outdoor-header", HeaderOutdoor);
}

if (!window.customElements.get("arcteryx-outdoor-footer")) {
  window.customElements.define("arcteryx-outdoor-footer", FooterOutdoor);
}
